<template>
    <v-btn
      class="base-dropdown-btn"
      :text="filled ? undefined : true"
      elevation="0"
      :to="to ? to : null"
      :target="target ? target : null"
      :href="href ? href : null"
      v-on="on ? on : null"
      v-bind="attrs ? attrs : null"
      :disabled="disabled"
      large
    >
        <v-icon
            v-if="!loading"
            size="16"
            :class="iconClass"
            >{{ icon }}</v-icon
        >
        <div
          v-else
          class="d-inline-flex align-center loading-inline-icon"
        >
          <loader
            :color="color ? color : 'primary'"
            size="16"
            :noMargins="true"
          />
        </div>
        <div
          class="p-d v-btn__text"
          :class="[textClass, loading ? 'loading' : '']"
          v-html="text"
        ></div>
    </v-btn>
  </template>
  
  <script>
  import Loader from "../Loader.vue";
  
  export default {
    components: {
      Loader,
    },
    props: {
      small: Boolean,
      icon: String,
      text: String,
      to: String,
      href: String,
      on: Object,
      attrs: Object,
      color: String,
      filled: Boolean,
      target: String,
      disabled: {
        type: Boolean,
        default: false,
      },
      loading: {
        type: Boolean,
        default: false,
      },
    },
    computed: {
      loadingColorClass() {
        return this.color ? `${this.color}--text` : "primary--text";
      },
      iconClass() {
        return this.color ? `${this.color}--text` : "heading--text";
      },
      textClass() {
        return this.loading ? this.loadingColorClass : (this.color ? `${this.color}--text` : "");
      },
    },
  };
  </script>
  
  <style lang="scss" scoped>
  .v-btn {
    .loading-inline-icon {
      min-width: 16px;
      min-height: 16px;
      margin-right: 6px;
    }
    &.primary-btn {
      &::v-deep {
        .v-btn__text {
          color: map-get($primary, darken1);
        }
        .v-icon {
          color: map-get($primary, darken1) !important;
        }
      }
    }
  }
  .v-application--is-rtl{
      .v-btn--vertical{
          .v-icon{
              margin-left: 0px;
          }
      }
      .loading-inline-icon {
        margin-right: 0;
        margin-left: 6px;
      }
  }
  </style>
  